import {
    NoteInsertionSource,
    NoteInsertionType,
    trackNoteInsertionEvent,
} from '../../../../../../analytics/noteInsertionAnalyticsUtils';
import { useActiveTiptapEditorCallback } from '../../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

const useDividerAction = () =>
    useActiveTiptapEditorCallback((editor) => {
        if (!editor) return;

        const inserted = editor.chain().focus(undefined, { scrollIntoView: false }).setHorizontalRule().run();

        if (!inserted) return;

        trackNoteInsertionEvent(NoteInsertionType.DIVIDER, NoteInsertionSource.INSERT_MENU);
    }, []);

export default useDividerAction;
